/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPrizeEntriesQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
  month: Types.Scalars['Float']['input'];
  year: Types.Scalars['Float']['input'];
}>;


export type GetPrizeEntriesQuery = { __typename?: 'Query', monthlyPrizeEntryCounts?: Array<{ __typename?: 'UserPrizeEntryCount', id: string, count: number } | null> | null, yearlyPrizeEntryCounts?: Array<{ __typename?: 'UserPrizeEntryCount', id: string, count: number } | null> | null };


export const GetPrizeEntriesDocument = gql`
    query getPrizeEntries($userId: ID!, $month: Float!, $year: Float!) {
  monthlyPrizeEntryCounts: userPrizeEntryCounts(
    filter: {user: {id: $userId}, periodType: "month", periodValue: $month}
  ) {
    id
    count
  }
  yearlyPrizeEntryCounts: userPrizeEntryCounts(
    filter: {user: {id: $userId}, periodType: "year", periodValue: $year}
  ) {
    id
    count
  }
}
    `;

/**
 * __useGetPrizeEntriesQuery__
 *
 * To run a query within a React component, call `useGetPrizeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrizeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrizeEntriesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      month: // value for 'month'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetPrizeEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetPrizeEntriesQuery, GetPrizeEntriesQueryVariables> & ({ variables: GetPrizeEntriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrizeEntriesQuery, GetPrizeEntriesQueryVariables>(GetPrizeEntriesDocument, options);
      }
export function useGetPrizeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPrizeEntriesQuery, GetPrizeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrizeEntriesQuery, GetPrizeEntriesQueryVariables>(GetPrizeEntriesDocument, options);
        }
export function useGetPrizeEntriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPrizeEntriesQuery, GetPrizeEntriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPrizeEntriesQuery, GetPrizeEntriesQueryVariables>(GetPrizeEntriesDocument, options);
        }
export type GetPrizeEntriesQueryHookResult = ReturnType<typeof useGetPrizeEntriesQuery>;
export type GetPrizeEntriesLazyQueryHookResult = ReturnType<typeof useGetPrizeEntriesLazyQuery>;
export type GetPrizeEntriesSuspenseQueryHookResult = ReturnType<typeof useGetPrizeEntriesSuspenseQuery>;
export type GetPrizeEntriesQueryResult = Apollo.QueryResult<GetPrizeEntriesQuery, GetPrizeEntriesQueryVariables>;